<template>
    <b-modal id="modalItemsExterna" data-backdrop="static" data-keyboard="false" v-model="exibirItens" centered
        :title="this.$t('Confirmar OS Externa')">
        <h3></h3>
        <p>{{ `${$t('Deseja realmente enviar OS')} N°${this.$route.params.id}?` }}</p>
        <v-select :options="getFornecedores" v-model="fornecedores" :placeholder="$t('Fornecedor')"></v-select>

        <div class="mt-3">
            <span for="obsItem">{{ $t('Observação') }}:</span>
            <input v-model="obsExterna" type="text" class="form-control" id="obsItem">
        </div>


        <template #modal-footer>
            <div class="w-100">
                <div class="row center" style="justify-content: center;">
                    <b-button class="mr-2" variant="danger" size="lg" @click="$emit('fechaModal')">
                        {{ $t('Cancelar') }}
                    </b-button>
                    <b-button size="lg" variant="success" @click="submitValues">
                        {{ $t('Enviar OS') }}
                    </b-button>
                </div>
            </div>
        </template>
    </b-modal>
</template>
<script>

export default {
    name: "ModalExterna",
    props: {
        os: {},
        item: {}
    },
    data() {
        return {
            selectServico: "",
            obsExterna: "",
            exibirItens: true,
            idConjunto: "",
            fornecedores: "",
            carregando: false
        };
    },
    computed: {
        getFornecedores() {
            const fornecedores = this.$store.getters['filial/fornecedores']

            if (!fornecedores) {
                this.$store.dispatch('filial/getFornecedores')
                return []
            }

            return fornecedores.map(fornecedor => {
                return {
                    ...fornecedor,
                    label: fornecedor.ds_fornecedor
                }
            })
        }
    },

    methods: {

        validaIntegracaoTicket(){
            this.$store.dispatch('os/integracaoTicket').then(response => {
                console.log(response)
                if(response.data.integracao_ticket) {
                    this.$swal.fire({
                    title: this.$t('Confirmar envio Ticket'),
                    text: `${this.$t('Deseja enviar para TicketLog a OS')} N°${this.$route.params.id}?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: this.$t('Confirmar')
                    }).then(result => {
                            if (result.dismiss !== 'cancel' && result.dismiss !== 'backdrop') {
                                const num_os = this.$route.params.id
                                const currentHost = window.location.hostname
                                let host = ''
                                this.carregando = true;


                                if (currentHost.includes('terminaldaoficina.inovess.com.br')) { host = 'https://ginfo.inovess.com.br/'  }
                                if (currentHost.includes('terminaldaoficina.ginfo.app.br')) { host = 'https://teste.ginfo.app.br/' }
                                if (currentHost.includes('localhost')) { host = 'https://localhost/ginfo/' }

                                // 🔄 Mostra o loading
                                this.$swal.fire({
                                    title: "Enviando Solicitação!",
                                    // html: "Estamos enviando sua ordem de serviço para a TicketLog, um momento...",
                                    html: `
                                    <div style="display: flex; flex-direction: column; align-items: center; gap: 16px;">
                                        <img src="/loading2.gif" alt="Carregando" style="height: 60px; width: 60px;"/>
                                        <p>Estamos enviando sua ordem de serviço para a TicketLog, um momento...</p>
                                    </div>
                                    `,
                                    // icon: "https://www.boasnotas.com/img/loading2.gif",
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    timerProgressBar: true,
                                    showConfirmButton: false,
                                });

                                fetch( host + 'rotinas/ticketlog/criar_solicitacao.php?os=' + num_os)
                                    .then(response => {
                                        if (!response.ok) {
                                        throw new Error(`Erro na requisição: ${response.status}`);
                                        }
                                        return response.text(); // ou .json() se o retorno for JSON
                                    })
                                    .then(data => {
                                        console.log('Resposta:', data);
                                        this.carregando = false;
                                        // ✅ Fecha o Swal de loading e mostra sucesso
                                        this.$swal.close(); // fecha o loading
                                        this.$swal.fire({
                                            icon: 'success',
                                            title: 'Enviado com sucesso!',
                                            text: 'A ordem de serviço foi enviada para a TicketLog.'
                                        });
                                    })
                                    .catch(error => {
                                        console.error('Erro:', error);
                                        // ❌ Fecha o Swal de loading e mostra erro
                                        this.$swal.close();
                                        this.$swal.fire({
                                            icon: 'error',
                                            title: 'Erro ao enviar',
                                            text: 'Houve um problema ao enviar a OS para a TicketLog.'
                                        });
                                });
                            } else if (result.dismiss == 'cancel'){
                                this.submitValues()
                            }
                        }
                    )
                } else {
                    this.submitValues()
                }
            })
        },
        submitValues() {
            const execucao = {
                nr_os: Number(this.$route.params.id),
                obs: this.obsExterna,
                adm: false,
                nr_seq_fornecedor: this.fornecedores.nr_sequencial
            }

            const filial = this.$store.getters['filial/filial']

            if (filial.atendeOs != "S") {
                execucao.adm = true
            }

            if (!this.item || !this.item.nr_sequencial) {
                this.$emit('enviaOsExterna', execucao)
                return
            }

            this.$store.dispatch('os/getDetails', { nrSequencial: this.$route.params.id }).then(response => {
                if (response.data.execucao_inicio) {
                    this.cod_item = this.item.nr_seq_item

                    const execucaoParar = {
                        id: this.item.execucao_final.id,
                        nr_seq_os_item_update: this.cod_item,
                        nr_seq_os_item: this.item.nr_sequencial,
                        nr_seq_os: this.$route.params.id,
                        nr_seq_clifor: response.data.execucao_inicio.nr_seq_clifor_inicio,
                        nr_os: this.$route.params.id,
                        validaExt: false,
                        obsExterna: this.obsExterna,
                        osExterna: false,
                    }

                    this.$emit('enviaOsExterna', { ...execucao }) 

                    this.$store.dispatch('osItemExecucao/update', { data: execucaoParar }).then(response => {
                        this.$store.dispatch('osItem/fetchItemFromApi', { nrSeqOs: this.$route.params.id, nrSequencial: this.item.nr_sequencial })
                        this.$store.dispatch('osItem/fetchItemFromApiPreventiva', { nrSeqOs: this.$route.params.id, nrSequencial: this.item.nr_sequencial })
                    })
                } else {
                    this.$emit('enviaOsExterna', { ...execucao })
                }

            })


        },

    },
}
</script>
<style>
    #modalItems {
        pointer-events: none !important;
    }

    .close {
        display: none !important;
    }

</style>
